export const defaultPageSize = 10;
export const defaultHeaders = { pageSize: defaultPageSize, pageNumber: 0 };
export const supportEmail = 'Support@CatholicCommunityApp.com';
export const currencyCode = '840';
export const tablePageSize = 10;
export const tableOffset = 10;
export const defaultOffset = 0;
export const merchantReportType = 'TODAY';
export const goalAmount = 0;
